import { render, staticRenderFns } from "./EvaluacionRespetoPrincipiosValoresCardComponent.vue?vue&type=template&id=4d6bbe3a"
import script from "./EvaluacionRespetoPrincipiosValoresCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipiosValoresCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports